// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"72":"114ada61","313":"121fe1fa","517":"4e1e41ba"}[chunkId] + ".css";
};